/* eslint-disable camelcase */
import React from 'react'
import DiningPackage from './DiningPackage'
import packageStyles from './diningpackages.module.sass'

export default props => {
  const { package_heading, package_text, packages } = props.diningpackages

  // if(props.bistromenus){
  return (
    <div className={packageStyles.diningpackages}>
      <div className={packageStyles.content}>
        <h3 className={packageStyles.heading}>{package_heading}</h3>
        <p className={packageStyles.text}>{package_text}</p>
        <ul className={packageStyles.list}>
          {packages.map(diningpackage => (
            <DiningPackage
              diningpackage={diningpackage}
              key={diningpackage.package_name}
            />
          ))}
        </ul>
      </div>
    </div>
  )
  // }
}

// diningpackages {
//   package_heading
//   package_text
//   packages {
//     package_name
//     package_description
//     price_per_person
//   }
// }
